const React = require('react');

const ContextContentMixin = require('./../context_content_mixin');
const CustomStylesMixin = require('./../custom_styles_mixin');
const RevealMixin = require('../reveal_mixin');

const createReactClass = require('create-react-class');

module.exports = createReactClass({

  displayName: '503',

  mixins: [ContextContentMixin, RevealMixin, CustomStylesMixin],

  render () {
    return (
      <div className="content-container">
        <div className="head-line" style={this.secondary_text_color()}>503</div>
        <div className="subheader" style={this.primary_text_color()}>
          Looks like we're having some server issues.
        </div>
        <hr style={this.hrBackgroundColor()} />
        <div className="clearfix" />
        <div className="context" style={this.primary_text_color()}>
          {this.contextContent()}
        </div>
        <div className="buttons-container">
          <a href={this.href(this.props.status_page_url)} style={this.mergeStyles(this.has_status_page(), this.borderButton())} target="_blank">View Status page</a>
          <a href={this.support_email_address()} style={this.borderButton()} target="_blank">Report A Problem</a>
        </div>
      </div>
    );
  },

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/plain/503.jsx